import { Text, Box, Image } from "@chakra-ui/react";
//import image
import groupImage from "./images/group16.jpg";
import image1 from "./images/chowdhury.jpg";

export default function AboutUs() {
  return (
    <div id="about-us">
      <Box
        padding="1rem"
        background="white"
        minHeight="100vh"
        marginInlineStart={{ base: "0", md: "0.1rem", xl: "1rem" }}
      >
        <Box textAlign="center">
          <Text fontSize="3xl" fontWeight={700}>
            About us
          </Text>
        </Box>
        <Box marginY="1rem">
          <Box>
            <Image
              src={groupImage}
              alt="qatar-uni-group-photo"
              marginX="auto"
              width={{ base: "95%", md: "92%", lg: "94%", xl: "92%" }}
            />
          </Box>
          <Text
            fontSize="2xl"
            fontWeight={700}
            textAlign="center"
            marginTop="10px"
          >
            Welcome
          </Text>

          <Text
            fontSize="18px"
            marginY="10px"
            textAlign="justify"
            width="94%"
            marginX="auto"
            padding={{ base: "0", md: "0.1rem", lg: "0.5rem", xl: "1rem" }}
          >
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque
            vestibulum hendrerit diam, eu varius lectus rhoncus eu. Cras a
            gravida odio. Cras ultricies felis porttitor pellentesque tempor.
            Curabitur vitae lacus sit amet urna molestie vulputate a vitae enim.
            Donec laoreet sodales vestibulum. Mauris placerat dui sed ex varius
            vestibulum. Cras egestas consectetur dapibus. Ut tincidunt vitae leo
            vel ornare. Pellentesque habitant morbi tristique senectus et netus
            et malesuada fames ac turpis egestas. Pellentesque iaculis tortor a
            placerat maximus. Sed ac felis et sapien gravida molestie. In libero
            eros, vehicula eu lacus in, mattis feugiat arcu. Praesent et dui
            dolor.
          </Text>
        </Box>
        <Box
          display="flex"
          flexDirection={{ base: "column", md: "column", lg: "row" }}
          justifyContent="space-between"
          alignItems={{
            base: "center",
            md: "center",
            lg: "flex-start",
            xl: "flex-start",
          }}
          marginY="20px"
          gap="26px"
          width="94%"
          marginX="auto"
          padding={{ base: "0", md: "0.1rem", lg: "0.5rem", xl: "1rem" }}
        >
          <Box flexShrink={0}>
            <Image
              src={image1}
              width={{ base: "70%", md: "296px", lg: "300px", xl: "400px" }}
              marginX="auto"
            />
          </Box>
          <Box>
            <Text
              fontSize={{ base: "20px", md: "xl", lg: "2xl", xl: "2xl" }}
              width={{ base: "80%", md: "81%", lg: "90%", xl: "60%" }}
              fontWeight={600}
              marginX={{ base: "auto", md: "auto", lg: "0px", xl: "0px" }}
            >
              MUHAMMAD E. H. CHOWDHURY, PH.D. (UK), SMIEEE
            </Text>

            <Text
              fontSize={{ base: "18px", md: "20px", lg: "22px", xl: "24px" }}
              marginY="10px"
              textAlign="justify"
            >
              Assistant Professor, Electrical Engineering, College of
              Engineering, Qatar University, Doha, Qatar.
            </Text>

            <Text
              fontSize="18px"
              marginY="10px"
              textAlign="justify"
              width={{ base: "94%" }}
            >
              Biomedical Instrumentation and Signal Processing, Image Processing
              and Computer Vision, Artificial Intelligence and Machine learning,
              Wireless Body Sensors, Smart Implant, Bio-nanomaterials, Antenna
              Technology, Driver Distraction Management, Artefact Correction for
              Simultaneous EEG-fMRI, Development of Novel method for EEG-fMRI,
              Mathematical Modelling of Human body in Electromagnetic field,
              Embedded system design.
            </Text>
          </Box>
        </Box>
      </Box>
    </div>
  );
}
